import type { MetadataInput } from '@/graphql/saleor/api';
import { ACCOUNT_METADATA } from '@/lib/metadata/const';

import { canSetCampaignCookie, getCampaignCookie } from './cookieManager';
import { normalizeUtmValue } from './utils';

/**
 * Build Saleor user metadata inputs for UTM attribution.
 *
 * Keys:
 * - user.utm_source
 * - user.utm_medium
 * - user.utm_campaign
 *
 * Rules:
 * - Always returns all 3 keys
 * - Empty strings when cookie absent or consent gating denies usage
 * - Truncates values to 255 chars (CPI requirement)
 */
export const getUserUtmMetadataInput = (
  countryCode: string,
): MetadataInput[] => {
  const empty = {
    utm_source: '',
    utm_medium: '',
    utm_campaign: '',
  };

  const canSet = canSetCampaignCookie(countryCode);
  const cookie = canSet ? getCampaignCookie() : null;
  const data = cookie ?? empty;

  return [
    {
      key: ACCOUNT_METADATA.utm_source,
      value: normalizeUtmValue(data.utm_source ?? ''),
    },
    {
      key: ACCOUNT_METADATA.utm_medium,
      value: normalizeUtmValue(data.utm_medium ?? ''),
    },
    {
      key: ACCOUNT_METADATA.utm_campaign,
      value: normalizeUtmValue(data.utm_campaign ?? ''),
    },
  ];
};
